import React, { useState, useEffect} from "react";
import { alpha, makeStyles } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import InputBase from "@material-ui/core/InputBase";
import { MenuItem, Link, Container } from "@material-ui/core";
import Menu from "@material-ui/core/Menu";
import MuiAlert from '@material-ui/lab/Alert';
import MailIcon from "@material-ui/icons/Mail";
import AccountCircleIcon from "@material-ui/icons/AccountCircle";
import AccountBalanceWalletIcon from "@material-ui/icons/AccountBalanceWallet";
import CollectionsIcon from '@material-ui/icons/Collections';
import { ReactSearchAutocomplete } from 'react-search-autocomplete';
import HeaderSearch  from './HeaderSearch';
import IconButton from "@material-ui/core/IconButton";
import InputAdornment from "@material-ui/core/InputAdornment";
import SearchIcon from "@material-ui/icons/Search";
import { truncateAddress } from "../../helpers/strings";
import { windowLocation } from "../../helpers/common";
import CopyToClipBoard from "../../componets/CopyToClipBoard";
import Drawer from "@material-ui/core/Drawer";
import Web3 from "web3";
import ExitToAppIcon from "@material-ui/icons/ExitToApp";
import FavoriteBorderIcon from '@material-ui/icons/FavoriteBorder';
import AccountTreeIcon from '@material-ui/icons/AccountTree';
import GrainIcon from '@material-ui/icons/Grain';
import MoreIcon from "@material-ui/icons/MoreVert";
import "bootstrap/dist/css/bootstrap.min.css";
import AddFundModal from "./AddFundModal";
import { NavMenu, NavItem } from "@mui-treasury/components/menu/navigation";
import { usePlainNavigationMenuStyles } from "@mui-treasury/styles/navigationMenu/plain";
import GoogleLogin from "react-google-login";
import Logo from "../../assets/Logo_mintjar_beta.svg";
import Logo2 from "../../assets/logo_text.svg";
import detectEthereumProvider from '@metamask/detect-provider';
import { BigNumber } from "bignumber.js";
import "../../styles/style.css";
// import { truncateString } from "../../helpers/strings";
import { Button } from "react-bootstrap";
import {OnboardingButton} from "../../Pages/metamaskButton"
import Meta from "../../assets/meta.png";
import {
  getWalletBalance,
  getNetwork,
  updateWalletAdress,
  getWeb3,
  loginMetamask,
  isAuthenticated,
  IsWalletConnected,
  connectViaMetaMask,
  getAuthObj,
  logout,
  onboardMetamask,
  responseGoogleSuccess,
  responseGoogleFailed,
  setMetamaskAccounts,
  isMetaMaskInstalled,
} from "../../webServices/loginServices";
import FacebookLogin from "react-facebook-login";
import "../../index.css";
import {
  usePopupState,
  bindTrigger,
  bindMenu,
} from "material-ui-popup-state/hooks";
import { Dropdown } from "react-bootstrap";
import { getWarehouseData } from "../../webServices/nftServices";

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: "#fff",
    color: "#000",
    boxShadow: "rgb(4 17 29 / 25%) 0px 0px 8px 0px;",
    zIndex: 99999,
  },
  grow: {
    flexGrow: 1,
  },
  paper: {
    width: 300,
    marginTop: 65,
  },

  menuButton: {
    marginRight: theme.spacing(2),
  },
  title: {
    display: "none",
    [theme.breakpoints.up("sm")]: {
      display: "block",
    },
  },
  
  // search: {
  //   position: "relative",
  //   borderRadius: theme.shape.borderRadius,
  //   backgroundColor: alpha(theme.palette.common.white, 0.15),
  //   "&:hover": {
  //     backgroundColor: alpha(theme.palette.common.white, 0.25),
  //   },
  //   marginRight: theme.spacing(2),
  //   marginLeft: 0,
  //   width: "100%",
  //   [theme.breakpoints.up("sm")]: {
  //     marginLeft: theme.spacing(1),
  //     marginRight: theme.spacing(3),
  //     // width: 'auto',
  //   },
  // },
  search: {
    position: 'relative',
    borderRadius: theme.shape.borderRadius,
    border:'1px solid #ddd',
    backgroundColor: alpha(theme.palette.common.white, 0.15),
    '&:hover': {
      backgroundColor: alpha(theme.palette.common.white, 0.25),
    },
    marginLeft: 0,
    width: '100%',
    [theme.breakpoints.up('sm')]: {
      marginLeft: theme.spacing(1),
      marginRight: theme.spacing(3),
      // width: 'auto',
    },
  },
  searchIcon: {
    padding: theme.spacing(0, 2),
    height: "100%",
    position: "absolute",
    pointerEvents: "none",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  inputRoot: {
    color: "inherit",
  },
  inputInput: {
    padding: theme.spacing(1, 1, 1, 0),
    // vertical padding + font size from searchIcon
    paddingLeft: `calc(1em + ${theme.spacing(4)}px)`,
    transition: theme.transitions.create("width"),
    width: "100%",
    [theme.breakpoints.up("sm")]: {
      width: "30ch",
      // '&:focus': {
      //   width: '20ch',
      // },
    },
  },
  menuBar: {
    display: "flex",
    justifyContent: "center",
  },
  sectionDesktop: {
    display: "none",
    [theme.breakpoints.up("md")]: {
      display: "flex",
    },
  },
  sectionMobile: {
    display: "flex",
    [theme.breakpoints.up("md")]: {
      display: "none",
    },
  },
  menuPaper: {
    zIndex: 9999,
    borderRadius: 10,
    minWidth: "250px !important",
    paddingTop: 20,
    paddingBottom: 20,
    background: "#fff",
    border: "1px solid #dddddd",
    // left:'-75px !important',
  },
  menuItems: {
    paddingBottom: 15,
    paddingTop: 15,
    borderBottom: "1px solid #ddd",
  },
}));

function Alert(props) {
	return <MuiAlert elevation={6} variant="filled" {...props} />;
}

export default function PrimarySearchAppBar() {
  let ProfileImage = null;
  if(localStorage.getItem("authObj"))
    ProfileImage = JSON.parse(localStorage.getItem("authObj")).ProfileImage;
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [mobileMoreAnchorEl, setMobileMoreAnchorEl] = React.useState(null);
  const isMobileMenuOpen = Boolean(mobileMoreAnchorEl);
  const handleMobileMenuClose = () => {
    setMobileMoreAnchorEl(null);
  };
  const handleMenuClose = () => {
    setAnchorEl(null);
    handleMobileMenuClose(false);
  };

  const [metamaskBalance, setMetamaskBalance] = useState("0");
  const [walletAddress, setWalletAddress] = useState(0);
  const [network, setNetwork] = useState();
  useEffect(async () => {
    if(IsWalletConnected()){
      const web3 = await getWeb3();
      const mynetwork = await getNetwork()
      setNetwork(mynetwork);
      setWalletAddress(getAuthObj().WalletAddress);
      const balance = await getWalletBalance();
      console.log(balance)
      console.log(typeof(balance))
      setMetamaskBalance(balance);
      const ethereum = window.ethereum;
      
      //-------------------------
      ethereum.on('chainChanged', async (chainId) => {
          const mynetwork = await getNetwork()
          console.log("🚀 ~ file: Header.js ~ line 218 ~ ethereum.on ~ mynetwork", mynetwork)
          setNetwork(mynetwork);
      });
       ethereum.on('accountsChanged', async (accountId) => {
        if (accountId.length>0){
          console.log("🚀 ~ file: Header.js ~ line 225 ~ ethereum.on ~ accountId", accountId)
          const accounts = await web3.eth.getAccounts();
          const balance = await getWalletBalance();
          setMetamaskBalance(balance);
          setWalletAddress(accounts[0]);
          updateWalletAdress(accounts[0],balance);
        }else {
          logout();
        }
        
        
      });


    }
  }, []);

  useEffect(() => {
    getWarehouseData();
  }, []);
  const array = localStorage.getItem("warehouse") ? JSON.parse(localStorage.getItem("warehouse")) : [];

  const [isDrawerOpened, setDrawerOpened] = useState(false);
    const DrawerToggle = () =>{
      // redirect
      if (!isAuthenticated()) {
        if(isMetaMaskInstalled()){
          if (window.ethereum._state.accounts.length > 0) {
              setMetamaskAccounts(window.ethereum._state.accounts);
            }else {
              localStorage.setItem("prevUrl", '/');
              setDrawerOpened(!isDrawerOpened);
            }
        } else {
          localStorage.setItem("prevUrl", '/');
              setDrawerOpened(!isDrawerOpened);
        }
      }else {
          localStorage.setItem("prevUrl", '/');
          setDrawerOpened(!isDrawerOpened);
      }
        
    }
  const DrawerClose = () => setDrawerOpened(false);

  const handleMobileMenuOpen = (event) => {
    setMobileMoreAnchorEl(event.currentTarget);
  };

  const popupState = usePopupState({
    variant: "popper",
    popupId: "demoPopper",
  });

  const renderSigninDrawer = (
    <div>
      <p
        style={{
          padding: 10,
          paddingLeft: 30,
          borderBottom: "1px solid rgb(229, 232, 235)",
          textAlign: "left",
          fontSize: "16px",
          fontWeight: 600,
        }}
      >
        <AccountCircleIcon style={{ marginRight: "10px" }} />
        Sign In
      </p>
      <div style={{ padding: 25 }}>
        <p
          style={{
            color: "rgb(112, 122, 131)",
            fontWeight: 400,
            fontSize: "16px",
          }}
        >
          <h6>Connect your wallet to sign-in</h6>
          <p>To buy and sell, Metamask wallet is required
          It only takes a minute!</p>

        </p>
        <div
          className="Signinbox"
          style={{
            borderRadius: "5px",
            border: "1px solid rgb(229, 232, 235)",
            padding: "20px",
          }}
        >
          <div className="LoginButton">
            <OnboardingButton>
              
            </OnboardingButton>
          </div>
          {/* <div className="LoginButton">
            <GoogleLogin
              className="btnGoogle"
              clientId="659915795219-holg20amggr1fle5p4fmch5r926dlbil.apps.googleusercontent.com"
              onSuccess={responseGoogleSuccess}
              onFailure={responseGoogleFailed}
              cookiePolicy={"single_host_origin"}
            />
          </div>
          <div className="LoginButton">
            <FacebookLogin
            icon="fa-facebook"
              cssClass="btnFacebook"
              appId="402520044740589"
              fields="name,email,picture"
            />
          </div>
          <div className="LoginButton">
            <a href="login" style={{ color: "white" }}>
              <Button className={"btnOther"} style={{ fontSize: "14px" }}>
                <MailIcon style={{ marginRight: 20 }} /> Sign in using email
              </Button>
            </a>
          </div>
           */}
        </div>
      </div>
    </div>
  );

  const renderProfileDrawer = (
    <div>
      <div className={"walletTopBar"}>
      <span>
        <AccountBalanceWalletIcon style={{ marginRight: 5 }} />
        Wallet
        </span>
        <CopyToClipBoard copyText={walletAddress} displayText={truncateAddress(walletAddress)} />
      </div>
      
      
      
      
      
      
      
      <div style={{ padding: 25 }}>
        <p
          style={{
            color: "rgb(112, 122, 131)",
            fontWeight: 400,
            fontSize: "16px",
          }}
        >
      
        </p>
        {/* <AddFundModal/> */}
        <div
          className="Signinbox"
          style={{
            border: "1px solid rgb(229, 232, 235)",
            padding: "20px",
            borderBottom: "none",
          }}
        >
          <p
            style={{
              color: "rgb(112, 122, 131)",
              fontWeight: 400,
              fontSize: "16px",
              textAlign: "center",
            }}
          >
            {/* Total Balance <br /> <b style={{color:'#000000'}}> {metamaskBalance ? metamaskBalance: 0} ETH</b> */}
            Total Balance <br /> <b style={{color:'#000000'}}> {metamaskBalance ? Math.round(Web3.utils.fromWei(metamaskBalance, "ether") * 1e4) / 1e4 : 0} ETH</b>
          </p>
        </div>
        <AddFundModal wallet={getAuthObj().WalletAddress}></AddFundModal>
        <Button onClick={logout} style={{width:'100%',marginTop:'10px',border:'solid 1px #1e82e4'}}variant="outlined" startIcon={<ExitToAppIcon />}>Logout</Button>
      </div>
    </div>
  );

  const menuId = "primary-search-account-menu";
  const renderMenu = (
    <Menu anchorEl={anchorEl} id={menuId} keepMounted>
      <Drawer
        variant="temporary"
        anchor="right"
        open={isDrawerOpened}
        onClose={DrawerClose}
        classes={{ paper: classes.paper }}
        // PaperProps={{ elevation: 9 }}
      >
        {!isAuthenticated() ? renderSigninDrawer : renderProfileDrawer}
      </Drawer>

      <Menu {...bindMenu(popupState)} style={{ marginTop: "40px" }}>
        <a href="/my-account" style={{ color: "black" }}>
          {" "}
          <MenuItem className={classes.menuItems} onClick={handleMenuClose}>
          {ProfileImage?<img src={ProfileImage} style={{width:' 24px', marginRight: 20, height: '24px', borderRadius: '50%'}} />:<AccountCircleIcon style={{ marginRight: 20 }} />}
            My Account
          </MenuItem>
        </a>
        <a href="/my-account?tab=favorites" style={{ color: "black" }}>
          <MenuItem className={classes.menuItems} >
            <FavoriteBorderIcon style={{ marginRight: 20 }} /> My Favorites
          </MenuItem>
        </a>
        {/* <a href="/my-account?tab=collected" style={{ color: "black" }}>
          <MenuItem className={classes.menuItems} >
            <AccountTreeIcon style={{ marginRight: 20 }} /> My
            Collection
          </MenuItem>
        </a>
        <a href="/my-account?tab=created" style={{ color: "black" }}>
          <MenuItem className={classes.menuItems}>
            <GrainIcon style={{ marginRight: 20 }} /> My Assets
          </MenuItem>
        </a> */}
        {!connectViaMetaMask('/') ? 
        <a href="/wallet" style={{ color: "black" }}>
        <MenuItem className={classes.menuItems} onClick={loginMetamask}>
          <AccountBalanceWalletIcon style={{ marginRight: 20 }} /> 
          Connect Wallet
        </MenuItem>
      </a>
        : ''}
        <MenuItem className={classes.menuItems} onClick={logout}>
          <ExitToAppIcon style={{ marginRight: 20 }} /> Logout
        </MenuItem>
      </Menu>
    </Menu>
  );

  const mobileMenuId = "primary-search-account-menu-mobile";
  const renderMobileMenu = (
    <div className="menu-aligns">
      <Menu
        anchorEl={mobileMoreAnchorEl}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        id={mobileMenuId}
        keepMounted
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        open={isMobileMenuOpen}
        onClose={handleMobileMenuClose}
      >
        {isAuthenticated() ?(
         <div> 
        <MenuItem className={classes.menuItems} onClick={handleMenuClose}>
          <AccountCircleIcon className="navIcon" style={{ marginRight: 20 }} />
          <a href="profiledataready" style={{ color: "black" }}>
            {" "}
            My Profile
          </a>
        </MenuItem>
        <MenuItem className={classes.menuItems} onClick={loginMetamask}>
          <CollectionsIcon className="navIcon" style={{ marginRight: 20, }} /> My Collection
        </MenuItem></div>
        )
        :''}
        
        {!isAuthenticated() ? (
          <MenuItem className={classes.menuItems} onClick={DrawerToggle}>
            <AccountCircleIcon className="navIcon" style={{ marginRight: 20 }} />
            Sign In
          </MenuItem>
        ) : (
          <MenuItem className={classes.menuItems} onClick={logout}>
            <ExitToAppIcon className="navIcon" style={{ marginRight: 20 }} /> Logout
          </MenuItem>
        )}
        <MenuItem className={classes.menuItems} onClick={loginMetamask}>
          {" "}
          <a alt="MintJar marketplace"
            href="/marketplace"
            style={{
              textDecoration: "none",
              justifyContent: "center",
              textAlign: "center",
              color: "red !important",
            }}
          >
            Browse
          </a>
        </MenuItem>
        <MenuItem className={classes.menuItems} onClick={loginMetamask}>
          {" "}
          <a  alt="MintJar create NFT"
            href="/assets/create"
            style={{
              textDecoration: "none",
              justifyContent: "center",
              textAlign: "center",
              color: "rgba(0, 0, 0, 0.54)",
            }}
          >
            Create
          </a>
        </MenuItem>
        <MenuItem className={classes.menuItems} onClick={loginMetamask}>
          {" "}
          <a
            alt="MintJar - Learn about NFT"
            href="/learn"
            style={{
              textDecoration: "none",
              justifyContent: "center",
              textAlign: "center",
              color: "rgba(0, 0, 0, 0.54)",
            }}
          >
            Learn
          </a>
        </MenuItem>
      </Menu>
    </div>
  );

  return (
    <div className={classes.grow}>
      <AppBar position="fixed" className={classes.root}>
        <Container maxWidth="lg">
          <Toolbar>
            {/* <IconButton
    edge="start"
    className={classes.menuButton}
    color="inherit"
    aria-label="open drawer"
  >
    <MenuIcon />
  </IconButton> */}
            <div className="logo-image">
              <a href="/" title="MintJar - NFT Marketplace to buy, sell, and mint easily">
                <img src={Logo} alt="MintJar - NFT Marketplace to buy, sell, and mint easily"/>
              </a>
            </div>
            <div className="logo-image-text">
              <a href="/">
                <img src={Logo2}  alt="MintJar - NFT Marketplace to buy, sell, and mint easily"/>
              </a>
            </div>
            {/* <div className="logo-text">
 Logo
 </div> */}

            {/* <div className={classes.grow} />
  <div className="expand-bar">
  <div className={classes.search}>
  { <div onClick={handleClick}>{ show ? <div className={classes.search}>
    <div className={classes.searchIcon}>
      <SearchIcon />
    </div>
    <InputBase
      placeholder="Search…"
      classes={{
        root: classes.inputRoot,
        input: classes.inputInput,
      }}
      inputProps={{ 'aria-label': 'search' }}
    />
  </div>
       : <SearchIcon />
      } </div>}
    
    
  </div>
  </div> */}
            <div className={classes.grow} />
            {/* <div className={classes.search}> */}
              
              {/* <InputBase
                placeholder="Search…"
                classes={{
                  root: classes.inputRoot,
                  input: classes.inputInput,
                }}
                inputProps={{ "aria-label": "search" }}
              /> */}
              {/* <div className="serach-sorts">
              <div className={classes.searchIcon}>
                <SearchIcon />
                
              </div>
              <select class="mdb-select md-form form-control" searchable="Search here..">
    <option disabled selected>Collections</option>
    <option>
      USA
      
    </option>
    <option>AIFIX</option>
                <option>Aether</option>
                <option>Adidas</option>
                <option>Artifex</option>
                <option disabled selected>Accounts</option>
    <option><img src="data:image/png;base64,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" />USA</option>
    <option>AIFIX</option>
                <option>All</option>
                <option>Annu</option>
                <option>A</option>
  </select>
             
              
              </div> */}
              <div  className="serach-sorts">
      <header>
        <div style={{position:'relative'}} class="sc-bxivhb frjscc">
        <SearchIcon style={{position: 'absolute',fontSize:'18px',fill: 'grey',zIndex: 1,top: '10px',left:'8px',}} />
          <HeaderSearch data={array} />
          </div>
        
      </header>
    </div>

            <div className={classes.grow} />
            <NavMenu
              className={classes.menuBar}
              useStyles={usePlainNavigationMenuStyles}
            >
              <div className="top-content top_nav_marg">
                <Link>
                  <NavItem active>
                    <a
                      href="/marketplace"
                      className="navHref"
                    >
                      Browse 
                    </a>
                  </NavItem>
                </Link>
              </div>
              <div className="top-content top_nav_marg">
                <NavItem>
                  <a
                    href="/assets/create"
                    className="navHref"
                  >
                    Create
                  </a>
                </NavItem>
              </div>
              <div className="top-content top_nav_marg">
                <NavItem>
                  <a
                    href="/learn"
                    className="navHref"
                  >
                    Learn
                  </a>
                </NavItem>
              </div>
              <div className="top-content ">
                <div className={classes.sectionDesktop}>
                  {!isAuthenticated() ? (
                    <NavItem
                      onClick={DrawerToggle}
                      style={{
                        textDecoration: "none",
                        color: "rgba(0, 0, 0, 0.54)",
                        cursor: "pointer",
                        marginTop:'6px'
                      }}
                    >
                      <div className="navHref" style={{ width: "75px" }}>
                        <AccountCircleIcon className="navHref" style={{ marginRight: 5 }} />
                        Sign In
                      </div>
                    </NavItem>
                  ) : (
                    <NavItem
                      style={{
                        textDecoration: "none",
                        color: "rgba(0, 0, 0, 0.54)",
                        cursor: "pointer",
                        paddingLeft: 60,
                        padding: 5,
                      }}
                    >
                      <span style={{padding: 4,borderRadius:'50%'}}  className="profileBg">
                      {ProfileImage?<img src={ProfileImage} style={{width:' 32px',  height: '32px', borderRadius: '50%'}} {...bindTrigger(popupState)} />:<AccountCircleIcon {...bindTrigger(popupState)} />}
                      </span>
                      
                      {getAuthObj().WalletAddress == "NAN" ? (
                        <span></span>
                      ) : (
                        <AccountBalanceWalletIcon
                          style={{ marginLeft: 10,width:'32px',height:'32px',fill:'#212121' }}
                          onClick={DrawerToggle}

                        />
                      )}
                    </NavItem>
                  )}
              
                </div>
              </div>
            </NavMenu>
            <div className={classes.grow} />

            <div className={classes.sectionMobile}>
              <IconButton
                aria-label="show more"
                aria-controls={mobileMenuId}
                aria-haspopup="true"
                onClick={handleMobileMenuOpen}
                color="inherit"
              >
                <MoreIcon />
              </IconButton>
            </div>
          </Toolbar>
        </Container>
        {
          network ? (
          network ==="Mainnet" ? "" : (
            <Alert  severity="warning">
              <p style={{textAlign:"center",color:"black",margin:0}}> You're viewing data from the main network, but your wallet is connected to the ({network}) network. To use Mintjar, please switch to Ethereum Mainnet network</p>
            </Alert>
          )
          ) : ""
        }
      </AppBar>
      {renderMobileMenu}
      {renderMenu}
    </div>
  );
}
